import { Scope } from '../types';

// Regex checks if scope contains 'openid' as a word and accounts for whitespace
// (^|\s) - start of string or whitespace
// openid - the word 'openid'
// ($|\s) - end of string or whitespace
const SCOPE_MATCHER = /(^|\s+)openid($|\s+)/gm;

/**
 * Validate that a scope is valid
 * @param scope
 */
export function validateScope(scope: string): Scope {
  if (scope.match(SCOPE_MATCHER)) {
    return scope.trim() as Scope;
  }
  return `openid ${scope}`.trim() as Scope;
}
